import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CookieModule } from 'ngx-cookie';

import { FooterNavSharedComponent } from './footer.nav.component';

@NgModule({
    declarations: [
        FooterNavSharedComponent
    ],
    imports: [
        CommonModule,
        CookieModule.forRoot()
    ],
    exports: [
        FooterNavSharedComponent
    ]
})

export class FooterNavSharedModule {}
